import { matchingApi } from "../../../api/apiClient";
function getMessageTypes() {
    return matchingApi.get("/messages")

  }
  function getFields(data)
  {
    return matchingApi.get(`/messages/${data}`)
  }

  function addNewRule(data)
  {
    return matchingApi.post(`/rules`,data)
  }

  function updateRule(data){
    return matchingApi.put(`/rules/${data.id}`, data)
  }
  function getRules() {
    return matchingApi.get('/rules')
  }

  function DeleteRule(data) {
    return matchingApi.delete(`/rules/${data}`)
  }

export const MatchingRuleService = {
    getMessageTypes,
    getFields,
    addNewRule,
    getRules,
    DeleteRule,
    updateRule
}